import http, { createApi } from '@core/fetch'

export default {
  getUnreadApi: body =>
    http('/p/wedding/home/APINotification/unread_type_count', {
      body
    }),
  /** 获取未读通知条数 */
  getNotifyUnreadCount: createApi(
    '/hms/messageCenter/appApi/merchant/notify/getReadCount'
  ),
  /** 主商家 */
  getMainNotifyUnreadCount: createApi(
    '/hms/messageCenter/appApi/merchant/notify/getParentMerchantReadCount'
  ),
  /** 主商家 */
  // getMainNotifyUnreadCount: createApi(
  //   '/p/wedding/index.php/mainAdmin/APINotification/unread_count'
  // ),
  getNoticeListApi: body =>
    http('/p/wedding/index.php/home/APINotification/index', { body }), //获取通知列表
  checkCommentApi: body =>
    http('/p/wedding/index.php/home/APIOrderComment/whether_deleted', { body }), //该评价是否已经删除
  readNoticeApi: body =>
    http.post('/p/wedding/home/APINotification/readed', {
      body
    }), //读取未读消息
  checkOrderStatusApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantOrder/info', { body }), //获取订单状态
  checkCertifyApi: body =>
    http('/p/wedding/Admin/APIMerchant/certify', { body }), //获取认证状态
  checkStoreStatusApi: body =>
    http('/p/wedding/index.php/admin/APIHotelOrderSub/detail', { body }) //获取体验店通知状态
}
